/* import __COLOCATED_TEMPLATE__ from './toast.hbs'; */
var _dec, _dec2, _dec3, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@ember/component';
import { FLASH_TYPES } from '@square/glass-ui/utils/flash-types';
import { computed } from '@ember/object';
import infoCircleIconComponent from '@square/glass-ui/components/svg/icon-info-circle';
import checkmarkCircleIconComponent from '@square/glass-ui/components/svg/icon-checkmark-circle';
import alertTriangleIconComponent from '@square/glass-ui/components/svg/icon-alert-triangle';
let Toast = (_dec = computed('type'), _dec2 = computed('type'), _dec3 = computed('type'), _class = class Toast extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "isActive", null);
    _defineProperty(this, "message", null);
    _defineProperty(this, "type", '');
  }
  get typeClass() {
    switch (this.type) {
      case FLASH_TYPES.ERROR:
        return 'toast-flash--is-error';
      default:
        return '';
    }
  }
  get iconComponentName() {
    switch (this.type) {
      case FLASH_TYPES.ERROR:
        return infoCircleIconComponent;
      case FLASH_TYPES.SUCCESS:
        return checkmarkCircleIconComponent;
      case FLASH_TYPES.WARNING:
        return alertTriangleIconComponent;
      default:
        return infoCircleIconComponent;
    }
  }
  get iconColor() {
    switch (this.type) {
      case FLASH_TYPES.ERROR:
        return 'white';
      case FLASH_TYPES.SUCCESS:
        return 'green';
      case FLASH_TYPES.WARNING:
        return 'gold';
      default:
        return 'blue-medium';
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "typeClass", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "typeClass"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "iconComponentName", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "iconComponentName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "iconColor", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "iconColor"), _class.prototype), _class);
export { Toast as default };